import { LanguageModel } from './language.model';
import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';
import { MorphModel } from './morph.model';

export class TextcontentModel extends BaseModel implements Deserializable {

  // columns
  title: string = null;
  content: string;

  // relations
  owner: MorphModel;
  language: LanguageModel;

  deserialize(input: any): this {
    Object.assign(this, input);
    // language
    if (this.language !== null && this.language !== undefined) {
      this.language = new LanguageModel().deserialize(this.language);
    }
    return this;
  }

}
